export const addPagePosts = (list) => {
  const postsList = document.querySelector('[data-blog-list]');

  if (postsList)
    postsList.appendChild(list)
}